
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import { Label } from "@/components/ui/label";
import { editorModules } from "./EditorConfig";

interface ContentEditorProps {
  value: string;
  onChange: (value: string) => void;
}

const ContentEditor = ({ value, onChange }: ContentEditorProps) => {
  return (
    <div className="space-y-2">
      <Label htmlFor="content-editor">Content</Label>
      <div className="min-h-[400px] border rounded-md">
        <ReactQuill
          theme="snow"
          value={value}
          onChange={onChange}
          modules={editorModules}
          className="h-[350px]"
        />
      </div>
    </div>
  );
};

export default ContentEditor;
